<template>
  <div class="text-center" :style="{ height: pageHeight }" style="overflow-y: auto;">
    <img v-if="$store.state.versionTemplateKey == 2" :src="`/capsiminbox/images/${$route.params.id}`" :alt="altText" style="max-width: 1200px">
  </div>
</template>

<script>
    export default {
        name: 'images',
        props:['id'],
        data() {
          return {
            windowHeight: 0,
          }
        },
        methods: {
          
        },
        computed: {
          pageHeight() {
              return `${this.windowHeight}px`
          },
          altText() {
            let retVal= ''
            switch( this.$route.params.id ) {
              case 'scatterplot.png':
                retVal = "Scatter Plot Graph";
                break;
              case 'boxplot.png':
                retVal = "Box Plot Graph";
                break;
              case 'supplydemand.jpg':
                retVal = "Supply/Demand Diagram";
                break;
              case 'BOM1.png':
                retVal = "Bill of Materials 1 Graph";
                break;
              case 'BOM2.png':
                retVal = "Bill of Materials 2 Graph";
                break;
              default:
                retVal = "Graph";
            } 
            return retVal
          },
        },
         beforeRouteEnter (to, from, next) {
            let title= ''
            switch( to.params.id ) {
              case 'scatterplot.png':
                title = "Scatter Plot";
                break;
              case 'boxplot.png':
                title = "Box Plot";
                break;
              case 'supplydemand.jpg':
                title = "Supply/Demand Diagram";
                break;
              case 'BOM1.png':
                title = "Bill of Materials 1";
                break;
              case 'BOM2.png':
                title = "Bill of Materials 2";
                break;
              default:
                title = "MODEX";
            } 
            document.title = title

          next()
        },
        mounted() {
          this.windowHeight = window.innerHeight
          this.$nextTick(() => {
              window.addEventListener('resize', () => {
                  this.windowHeight = window.innerHeight
              });
          })
        }
    }
</script>